export default __webpack_public_path__ + "static/media/Tekena Sukubo.c764db8f.jpg";